import * as React from 'react'
import { Spinner } from '@amzn/dvui/dist/Spinner'
import * as st from './spinners.module.scss'
import * as cn from 'classnames'

const DEFAULT_DELAY = 350

export type SpinnerWithDelayProps = {
  isLoading: boolean,
  delay?: number,
  spinner?: React.ReactElement<any>,
  children?: React.ReactNode,
}

type State = {
  showSpinner: boolean
}

export class SpinnerWithDelay extends React.Component<SpinnerWithDelayProps, State> {
  timer: any = null
  state = {
    showSpinner: false
  }

  componentDidMount() {
    this.ensureTimer(this.props)
  }

  componentWillUnmount() {
    this.destroyTimer()
  }

  componentDidUpdate(prevProps: SpinnerWithDelayProps) {
    if (prevProps.isLoading !== this.props.isLoading) {
      this.ensureTimer(this.props)
    }
  }

  ensureTimer({ isLoading, delay = DEFAULT_DELAY }: SpinnerWithDelayProps) {
    if (isLoading) {
      if (!this.timer) {
        this.timer = setTimeout(() => {
          this.timer = null;
          this.setState({ showSpinner: true })
        }, delay);
      }
    } else {
      this.destroyTimer()
    }
  }

  destroyTimer() {
    clearTimeout(this.timer)
    this.timer = null
    this.setState({ showSpinner: false })
  }

  render() {
    const { spinner = <SpinnerWithWrapper />, children } = this.props

    return <>
      {this.state.showSpinner && spinner}
      {children && <span className={cn(st.content, { [st.isLoading]: this.state.showSpinner })}>{children}</span>}
    </>
  }
}

const SpinnerWithWrapper = () => {
  return (
    <div className={st.spinnerWrapper}>
      <div className={st.spinner}>
        <Spinner fillHeight />
      </div>
    </div>
  )
}
